import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import CidadesContext from '../context/cidades.context';
import UsuarioContext from '../context/usuario.context';
import {
  fetchLocations2, fetchState, fetchCitiesByIdState, fetchCitiesByUf,
} from '../services/apis';

export function ProviderCidades({ children }) {
  const { setUsuario, usuario } = useContext(UsuarioContext);
  const [listUf, setListUf] = useState([]);
  const [listCity, setListCity] = useState([]);
  const [actualLocation, setActualLocation] = useState([0, 0]);

  function handleChange({ target }) {
    const { name, value } = target;

    if (name === 'cidade' || name === 'estado') {
      if (name === 'estado') {
        for (let index = 0; index < listUf.length; index += 1) {
          const element = listUf[index];
          if (listUf[index].id === parseInt(value, 10)) {
            const estado = element.nome;
            fetchCitiesByIdState(value).then((data) => {
              data.sort((a, b) => a.nome.localeCompare(b.nome));
              setListCity([...data]);
              const cidade = data[0].nome;

              fetchLocations2(cidade, estado).then(({
                latitude, longitude, estado: sigla,
              }) => {
                setUsuario((prevState) => ({
                  ...prevState, cidade, estado: sigla, latitude, longitude,
                }));
                setActualLocation([latitude, longitude]);
              }).catch(() => {});
            });
          }
        }
      } else {
        fetchLocations2(value, usuario.estado).then(({
          latitude, longitude, estado: sigla, cidade,
        }) => {
          setUsuario((prevState) => ({
            ...prevState, name, estado: sigla, latitude, longitude, cidade,
          }));
          setActualLocation([latitude, longitude]);
        }).catch(() => {});
      }
    } else {
      setUsuario((prevState) => ({
        ...prevState, [name]: value,
      }));
    }
  }

  function findLocation(city, state) {
    fetchLocations2(city, state).then(({
      latitude, longitude, cidade, estado,
    }) => {
      setUsuario((prevState) => ({
        ...prevState, cidade, estado, latitude, longitude,
      }));
    }).catch(() => {});
  }

  function findLocationWhithUf(state) {
    fetchCitiesByIdState(state).then((cidades) => {
      cidades.sort((a, b) => a.nome.localeCompare(b.nome));
      setListCity([...cidades]);
    }).catch(() => {});
  }

  function findLocationSiglaUf(state) {
    fetchCitiesByUf(state).then((cidades) => {
      cidades.sort((a, b) => a.nome.localeCompare(b.nome));
      setListCity([...cidades]);
      const { nome: cidade } = cidades[0];
      fetchLocations2(cidade, state).then(({
        latitude, longitude, estado: sigla,
      }) => {
        setUsuario((prevState) => ({
          ...prevState, latitude, longitude, cidade, sigla,
        }));
        setActualLocation([latitude, longitude]);
      });
    }).catch(() => {});
  }

  function loadCity(id) {
    fetchCitiesByIdState(id).then((data) => {
      data.sort((a, b) => a.nome.localeCompare(b.nome));
      setListCity([...data]);
    });
  }

  function loadUf() {
    fetchState().then((estados) => {
      estados.sort((a, b) => a.nome.localeCompare(b.nome));
      setListUf([...estados]);
      const { id, sigla: estado } = estados[0];
      loadCity(id);
      fetchCitiesByIdState(id).then((cidades) => {
        cidades.sort((a, b) => a.nome.localeCompare(b.nome));
        setListCity([...cidades]);
        const { nome: cidade } = cidades[0];
        fetchLocations2(cidade, estado).then(({
          latitude, longitude, estado: sigla,
        }) => {
          setUsuario((prevState) => ({
            ...prevState, latitude, longitude, cidade, sigla,
          }));
          setActualLocation([latitude, longitude]);
        });
      }).catch(() => {});
    });
  }

  useEffect(() => {
    loadUf();
  }, []);

  const shared = {
    listCity,
    setListCity,
    loadUf,
    listUf,
    setListUf,
    handleChange,
    findLocation,
    actualLocation,
    setActualLocation,
    findLocationWhithUf,
    findLocationSiglaUf,
  };

  return (
    <>
      <CidadesContext.Provider value={{ ...shared }}>
        {children}
      </CidadesContext.Provider>
    </>
  );
}
ProviderCidades.propTypes = {
  children: PropTypes.node.isRequired,
};
